document.addEventListener('DOMContentLoaded', function () {
    function equalizeIntroCarouselCards() {
        document.querySelectorAll('.intro-carousel-wrapper .carousel').forEach(function (carousel) {
            const cards = carousel.querySelectorAll('.intro-carousel-card');
            if (cards.length === 0) return;

            // reset, then measure the tallest
            let maxHeight = 0;
            cards.forEach(function (card) {
                card.style.minHeight = '';
                maxHeight = Math.max(maxHeight, card.offsetHeight);
            });

            // set all to the tallest
            cards.forEach(function (card) {
                card.style.minHeight = maxHeight + 'px';
            });
        });
    }

    window.addEventListener('load', equalizeIntroCarouselCards);

    let introCarouselResizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(introCarouselResizeTimer);
        introCarouselResizeTimer = setTimeout(equalizeIntroCarouselCards, 250);
    });
});